<template>
  <div class="name d-inline">
    {{ name }}
  </div>
</template>

<script>
export default {
  name: "CommunityKey",
  props: ['value'],
  computed: {
    name () { return this.value.name },
    namespace () { return this.value.namespace }
  }
}
</script>

<style lang="sass">
</style>
